@if (form) {
<form [formGroup]="form" class="cadastro">
    <section class="block">
        <h3>Contatos</h3>
        @if (producer?.contacts?.length) {
        <ul class="rows">
            @for (contact of producer?.contacts; track contact) {
            <li>
                <span class="label">{{ contactLabel(contact.category) }}</span>
                <span class="value">{{ contact.detail || '—' }}</span>
            </li>
            }
        </ul>
        } @else {
        <p class="empty">Nenhum contato cadastrado</p>
        }
    </section>

    <section class="block">
        <h3>Endereços</h3>
        @if (formattedAddresses.length) {
        <ul class="rows addresses">
            @for (addr of formattedAddresses; track addr; let i = $index) {
            <li>
                <span class="label">Endereço {{ i + 1 }}</span>
                <div class="addr">
                    @for (line of addr; track line) {
                    <span>{{ line }}</span>
                    }
                </div>
            </li>
            }
        </ul>
        } @else {
        <p class="empty">Nenhum endereço cadastrado</p>
        }
    </section>
</form>
}
